import * as Sentry from '@sentry/react';

export const captureError = (error, context = {}) => {
  Sentry.captureException(error, { extra: context });
};

export const captureMessage = (message, level = 'info') => {
  Sentry.captureMessage(message, level);
};

export const setUserContext = (user) => {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.username || user.name,
  });
};

export const addBreadcrumb = (message, category = 'custom') => {
  Sentry.addBreadcrumb({
    message,
    category,
    level: 'info',
    timestamp: Date.now() / 1000,
  });
};

export const setTag = (key, value) => {
  Sentry.setTag(key, value);
};

export const setContext = (key, context) => {
  Sentry.setContext(key, context);
}; 